import { createActions, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  APP_LAUNCH: 'APP_LAUNCH',
  APP_LAUNCH_SUCCESS: 'APP_LAUNCH_SUCCESS',
  APP_LAUNCH_FAILED: 'APP_LAUNCH_FAILED',
};

export const { appLaunch, appLaunchSuccess, appLaunchFailed } = createActions({
  [types.APP_LAUNCH]: (lang) => ({ lang }),
  [types.APP_LAUNCH_FAILED]: (errorMessage) => ({ errorMessage }),
  [types.APP_LAUNCH_SUCCESS]: ({
    subjects,
    rateMessages,
    searchSubjects,
    typeformUrl,
    region,
    personalPubnubChannel,
    webOpendQaNotifyPubnubChannel,
    hideTimeBasedQuestionEntry,
    locale,
  }) => ({
    subjects,
    rateMessages,
    searchSubjects,
    typeformUrl,
    region,
    personalPubnubChannel,
    webOpendQaNotifyPubnubChannel,
    hideTimeBasedQuestionEntry,
    locale,
  }),
});

const INIT_STATE = {
  loadingStatus: loadingState.EMPTY,
  subjects: [],
  searchSubjects: [],
  rateMessages: {},
  typeformUrl: '',
  region: '',
  personalPubnubChannel: '',
  webOpendQaNotifyPubnubChannel: '',
  hideTimeBasedQuestionEntry: false,
  locale: '',
};

const reducer = handleActions(
  {
    [types.APP_LAUNCH]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
    }),
    [types.APP_LAUNCH_SUCCESS]: (state, action) => {
      const {
        subjects,
        searchSubjects,
        rateMessages,
        typeformUrl,
        region,
        personalPubnubChannel,
        webOpendQaNotifyPubnubChannel,
        hideTimeBasedQuestionEntry,
        locale,
      } = action.payload;

      return {
        ...state,
        loadingStatus: loadingState.READY,
        subjects,
        searchSubjects,
        rateMessages,
        typeformUrl,
        region,
        personalPubnubChannel,
        webOpendQaNotifyPubnubChannel,
        hideTimeBasedQuestionEntry,
        locale,
      };
    },
    [types.APP_LAUNCH_FAILED]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
  },
  INIT_STATE
);

export default reducer;
export const getAppParams = (state) => state.app;
export const getSubjects = createSelector(getAppParams, (app) => app.subjects);
export const getSearchSubjects = createSelector(
  getAppParams,
  (app) => app.searchSubjects
);
export const getRateMessages = createSelector(
  getAppParams,
  (app) => app.rateMessages
);
export const getTypeformUrl = createSelector(
  getAppParams,
  (app) => app.typeformUrl
);
export const getRegion = createSelector(getAppParams, (app) => app.region);
export const getAppLocale = createSelector(getAppParams, (app) => app.locale);

export const getPersonalPubnubChannel = createSelector(
  getAppParams,
  (app) => app.personalPubnubChannel
);

export const getWebOpendQaNotifyPubnubChannel = createSelector(
  getAppParams,
  (app) => app.webOpendQaNotifyPubnubChannel
);

export const getHideTimeBasedQuestionEntry = createSelector(
  getAppParams,
  (app) => app.hideTimeBasedQuestionEntry
);



// WEBPACK FOOTER //
// ./src/services/redux/app.js